
export const AgencyInputs = [
    {
        label: 'Nome azienda',
        name: 'nome',
        placeholder: 'Nome azienda',
        type: 'text',
        validators: {
            required: 'Il nome è obbligatorio'
        },
        type_input: 'input',
        size_input: 'w-full',
    },
]